import { ICellRendererParams } from 'ag-grid-community';
import { Button, Tag, Typography } from '@navi/web-ui/lib/primitives';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import EllipsisText from '@cp/src/components/EllipsisText';
import { useNavigate } from 'react-router-dom';
import APP_ROUTES from '@cp/src/layout/Routes';

const VIEW_PRODUCTS_COL_DEFS = () => {
  const navigate = useNavigate();
  return [
    {
      field: 'productCode',
      headerName: 'Product Code',
      cellRenderer: (params: ICellRendererParams) => {
        return <div>{params.value}</div>;
      }
    },
    {
      field: 'productName',
      headerName: 'Product Name',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
            <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
              <EllipsisText text={params.value} />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">{params.value}</TooltipContent>
          </Tooltip>
        );
      }
    },
    {
      field: 'productType',
      headerName: 'Product Type',
      serverSortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        return <EllipsisText text={params.value} />;
      }
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      serverSortable: true,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        return <div>{params.value}</div>;
      }
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Tooltip placement="top" hiddenPadding={0} hideStrategy="referenceHidden">
            <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
              <EllipsisText text={params.value} />
            </TooltipTrigger>
            <TooltipContent className="tooltipWrapper">{params.value}</TooltipContent>
          </Tooltip>
        );
      }
    },
    {
      field: '',
      headerName: '',
      cellRenderer: (params: ICellRendererParams) => {
        const toViewTimelines = APP_ROUTES.PARAMOUNT_TIMELINES;
        return (
          <Button
            variant="primary"
            size="small"
            onClick={() => navigate(`${toViewTimelines.path}?product=${params?.data?.productCode}`)}
          >
            View Timelines
          </Button>
        );
      }
    }
  ];
};

export default VIEW_PRODUCTS_COL_DEFS;
